<template>
<div class="chapter">
<div class="inner_page">
<h2 class="Abb"><a id="pageix">Abbreviations</a></h2><a id="pageix">
<p class="noindent"><span class="bold">BEF</span> – British Expeditionary Force</p>
<p class="noindent"><span class="bold">CIGS</span> – Chief of the Imperial General Staff</p>
<p class="noindent"><span class="bold">DCIGS</span> – Deputy Chief of the Imperial General Staff</p>
<p class="noindent"><span class="bold">DDMI(I)</span> – Deputy Director, Military Intelligence (Intelligence)</p>
<p class="noindent"><span class="bold">DDMI(O)</span> – Deputy Director, Military Intelligence (Operations)</p>
<p class="noindent"><span class="bold">DDMI(R)</span> – Deputy Director, Military Intelligence (Research)</p>
<p class="noindent"><span class="bold">D/M</span> – Unofficial title briefly replacing GS(R) in April 1939</p>
<p class="noindent"><span class="bold">DMI</span> – Director of Military Intelligence</p>
<p class="noindent"><span class="bold">DMT</span> – Directorate of Military Training</p>
<p class="noindent"><span class="bold">DSR</span> – Directorate of Scientific Research</p>
<p class="noindent"><span class="bold">GC&amp;CS</span> – Government Code and Cypher School</p>
<p class="noindent"><span class="bold">GHQ</span> – General Headquarters</p>
<p class="noindent"><span class="bold">G(R)</span> – formal name of MI(R) Middle East</p>
<p class="noindent"><span class="bold">GSO</span> – General Staff Officer (in Grades 1–3)</p>
<p class="noindent"><span class="bold">GS(R)</span> – General Services (Research). The research unit from which MI(R) was formed</p>
<p class="noindent"><span class="bold">HDS</span> – Home Defence Scheme of Section D</p>
<p class="noindent"><span class="bold">ISPB</span> – Inter-Services Project Board</p>
<p class="noindent"><span class="bold">ISSB</span> – Inter-Services Security Board</p>
<p class="noindent"><span class="bold">IWM</span> – Imperial War Museum</p>
<p class="noindent"><span class="bold">LDV</span> – Local Defence Volunteers (original name of the Home Guard</p>
<p class="noindent"><span class="bold">LRDG</span> – Long Range Desert Group</p>
<p class="noindent"><span class="bold">MD1</span> – The designation of MI(R)c after its transfer to the Ministry of Defence</p>
<p class="noindent"><span class="bold">MI1(a)</span> – Distribution of reports and intelligence records</p>
<p class="noindent"><span class="bold">MI1(c)</span> – The designation for SIS within the War Office</p>
<p class="noindent"><span class="bold">MI1(R)</span> – Official title of what is usually known as MI(R) or MIR in June 1939 to formally replace GS(R)</p>
<p class="noindent"><span class="bold">MI3</span> – Geographical information</p>
<p class="noindent"><span class="bold">MI5</span> – Security Service</p>
<p class="noindent"><span class="bold">MI6</span> – Popular name of SIS</p>
<p class="noindent"><span class="bold">MI7</span> – Propaganda and Censorship</p>
<p class="noindent"><span class="bold">MI9</span> – Escape and Evasion organization</p>
<p class="noindent"><span class="bold">MI10</span> – Weapons and Technical Intelligence</p>
<p class="noindent"><span class="bold">MI11</span> – Field Security</p>
</a><p class="noindent"><a id="pageix"></a><a id="pagex"><span class="bold">MIL</span> – Liaison, Arms traffic and Law</a></p><a id="pagex">
<p class="noindent"><span class="bold">MIR</span> – Alternative form of MI(R) in contemporary documents from June 1940</p>
<p class="noindent"><span class="bold">MI(R)</span> – Military Intelligence Research department from June 1940</p>
<p class="noindent"><span class="bold">MI(R)a</span> – Coordination of Projects and Services section of MI(R)</p>
<p class="noindent"><span class="bold">MI(R)b</span> – Special Operations and Political Action section of MI(R)</p>
<p class="noindent"><span class="bold">MI(R)c</span> – Technical section of MI(R), later transferred to the Ministry of Defence as MD1</p>
<p class="noindent"><span class="bold">MO9</span> – Military Operations department created to manage the Commandos</p>
<p class="noindent"><span class="bold">NID</span> – Naval Intelligence Department</p>
<p class="noindent"><span class="bold">NWEF</span> – North Western Expeditionary Force (Norway campaign)</p>
<p class="noindent"><span class="bold">OCTU</span> – Officer Cadet Training Unit</p>
<p class="noindent"><span class="bold">OER</span> – Officers Emergency Reserve</p>
<p class="noindent"><span class="bold">PUS</span> – Permanent Under-Secretary of State</p>
<p class="noindent"><span class="bold">RARO</span> – Regular Army Reserve of Officers</p>
<p class="noindent"><span class="bold">SAS</span> – Special Air Service</p>
<p class="noindent"><span class="bold">Section D</span> – Sabotage section of SIS, which worked closely with MI(R)</p>
<p class="noindent"><span class="bold">SIME</span> – Security Intelligence, Middle East</p>
<p class="noindent"><span class="bold">SIS</span> – Secret Intelligence Service, popularly known as MI6</p>
<p class="noindent"><span class="bold">SOE</span> – Special Operations Executive</p>
<p class="noindent"><span class="bold">SPD</span> – German Social Democratic Party (Sozialdemokratische Partei)</p>
<p class="noindent"><span class="bold">STS</span> – Special Training School (of SOE)</p>
<p class="noindent"><span class="bold">TA</span> – Territorial Army</p>
<p class="noindent"><span class="bold">TARO</span> – Territorial Army Reserve of Officers</p>
<p class="noindent"><span class="bold">TNA</span> – The National Archives</p>
<p class="noindent"><span class="bold">VCIGS</span> – Vice Chief of the Imperial General Staff</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Abbreviations.vue?069e3798